export { I18nProvider } from '../src/I18nProvider';
